import { Service } from "./service";

export type Product = {
    id: string;
    equipmentType: string;
    latitude: number;
    longitude: number;
    assetCount: number;
    availableAssetCount: number;
    occupiedAssetCount: number;
    unknownAssetCount: number;
    services: Service[];
}

export type ProductInfos = {
    serviceId: string;
    productTariffId: string
}

export function hasAvailableAsset(product: Product): boolean {
    return product.availableAssetCount > 0;
}